import { Thumbnail } from 'design-system-web';

export default Thumbnail;
